export const BLOCKED_PATHS: Record<string, string[]> = {
  en: [
    'brand-partnerships',
    'super-rebel-loyalty-club',
    'rating/*',
    'order/*',
    'cart',
    'checkout',
    'overview/*',
    'privacy-policy',
    'estimate/new',
    'edit-delivery/*',
    'edit-pickup/*',
  ],
  de: [
    'marken-partnerschaften',
    'super-rebel-loyalty-club',
    'rating/*',
    'order/*',
    'cart',
    'checkout',
    'overview/*',
    'datenschutzerklaerung',
    'estimate/new',
    'edit-lieferung/*',
    'bearbeiten-abholung/*',
  ],
};

const buildRegexFromPattern = (pattern: string): RegExp => {
  const p = pattern.replace(/^\/+|\/+$/g, '');

  if (p.endsWith('/*')) {
    const prefix = p.slice(0, -2).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return new RegExp(`^/${prefix}($|/.*)`);
  }

  const escaped = p.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`^/${escaped}($|/)`);
};

const BLOCKED_REGEXES: RegExp[] = Object.values(BLOCKED_PATHS)
  .flat()
  .map(buildRegexFromPattern);

export const isPathBlocked = (rawPath: string): boolean => {
  const path = rawPath.split(/[?#]/)[0];
  return BLOCKED_REGEXES.some((r) => r.test(path));
};

export default BLOCKED_PATHS;
